import { useEffect } from 'react';
import { consumeReturnTo } from './return-to.js';

const assignLocation = (url: string): void => window.location.assign(url);

/**
 * Для оператора, у которого сессия УЖЕ есть: admin-api прислал его на
 * `/?returnTo=…/docs/mcp`, логин-форма не показывается, поэтому возврат
 * делает гейт панели. Как только `signedIn`, забирает отложенный `returnTo`
 * (повторно проверенный allowlist'ом) и уводит браузер туда.
 *
 * Гейт при этом продолжает рисовать панель как обычно: «пустой экран, пока
 * уходим» после «Назад» из bfcache так и остался бы пустым.
 */
export function useLeaveForReturnTo(
  signedIn: boolean,
  apiOrigin: string,
  assign: (url: string) => void = assignLocation,
): void {
  useEffect(() => {
    if (!signedIn) return;
    // `consumeReturnTo` empties the storage, so a re-run never navigates twice.
    const url = consumeReturnTo(apiOrigin);
    if (url) assign(url);
  }, [signedIn, apiOrigin, assign]);
}
